import { AIRBNB_URL, PROPERTY } from "@/data/property";

const NAV = [
  { label: "Gallery", href: "#gallery" },
  { label: "Amenities", href: "#amenities" },
  { label: "Sleeping", href: "#sleeping" },
  { label: "Location", href: "#location" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] relative overflow-hidden">
      <div className="grain-overlay" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="font-display font-semibold text-2xl text-white">{PROPERTY.name}</div>
            <p className="mt-2 text-white/60 font-body">{PROPERTY.tagline} · {PROPERTY.location}</p>
            <a
              href={AIRBNB_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-btn"
              className="mt-6 inline-flex items-center rounded-full bg-[#1FB6C9] px-6 py-3 font-display font-medium text-white transition-transform duration-300 hover:-translate-y-0.5"
            >
              Book Now
            </a>
          </div>
          <div>
            <div className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body mb-5">Explore</div>
            <ul className="grid grid-cols-2 gap-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-white/70 font-body hover:text-[#1FB6C9] transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body mb-5">Stay Details</div>
            <ul className="space-y-3 text-white/70 font-body">
              <li>8 bedrooms · 18 beds · 9 baths</li>
              <li>Sleeps up to 24 guests</li>
              <li>Check-in 3:00 PM · Checkout 11:00 AM</li>
              <li>Managed by Elite STR Hosting Co.</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-white/40 text-sm font-body">
          <span>© {new Date().getFullYear()} {PROPERTY.name}. All rights reserved.</span>
          <span>Canyon Lake, Texas · Waterfront Luxury Retreat</span>
        </div>
      </div>
    </footer>
  );
}
